import { AccessTokenResponse } from "../api/types";

export const setTokenFromResponse = (tokenResponse: AccessTokenResponse) => {
  localStorage.setItem("UserToken", tokenResponse.token);
  const expireAt = new Date(tokenResponse.expireAt);
  localStorage.setItem("ExpireAt", expireAt.toISOString());
  localStorage.setItem("RefreshToken", tokenResponse.refreshToken.token);
  const refreshTokenExpireAt = new Date(tokenResponse.refreshToken.expireAt?.toString() || "");
  localStorage.setItem(
    "RefreshTokenExpire",
    refreshTokenExpireAt ? refreshTokenExpireAt.toISOString() : ""
  );
};